import styled, { css } from 'styled-components';
import { pxToRem } from '../../../utils/scss';

export const AdvancedSearchContainer = styled.div`
  max-width: 100%;
  height: ${props => pxToRem(`${props.sectionHeight}px`)};
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 ${pxToRem('6px')} ${pxToRem('12px')} -${pxToRem('4px')} ${props => props.theme.colors.black.five};
  border-radius: ${pxToRem('8px')};

  ${props =>
    props.sectionHeight !== '0' &&
    css`
      padding: ${pxToRem('24px')};
    `}
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: ${pxToRem('34px')};
  gap: ${pxToRem('5px')};
  align-items: center;
`;

export const SingleInputContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: ${pxToRem('100px')};
  flex-shrink: 0;
`;

export const ErrorContainer = styled.div`
  padding: 0 ${pxToRem('16px')};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: ${pxToRem('100px')};
  flex-shrink: 0;
  padding-top: ${pxToRem('12px')};
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
